import type { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { mutatorAction } from 'satcheljs';

export const toggleSplitMode = mutatorAction(
    'toggleSplitMode',
    function toggleSplitMode(store: CalendarSurfaceStore): void {
        store.isInSplitView = !store.isInSplitView;
    }
);
